/* WideStep navigation chrome behaviour — ported from the approved Menu design.
   Announce rotation, Help dropdown, hover mega menus, accessible slide-out drawer
   with sub-views + accordions + focus trap, mobile search overlay, Shoe Finder quiz. */
(function () {
  'use strict';

  var SHOE = '<svg viewBox="0 0 64 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 27c0-2 1-3 3-3 4 0 7-1 10-3l8-6c2-1 4-1 6 1l3 4c2 2 5 3 8 3l9 1c4 .5 6 2 6 5 0 2-2 4-5 4H8c-3 0-5-2-5-5z" fill="#22335A" opacity=".22"/><path d="M3 30h58" stroke="#22335A" stroke-width="2" opacity=".4" stroke-linecap="round"/></svg>';

  /* US flag */
  function WSflag(f) {
    if (f.dataset.fl) return; f.dataset.fl = '1';
    f.style.cssText = 'display:inline-block;width:1.2em;height:0.9em;border-radius:2px;box-shadow:0 0 1px rgba(0,0,0,.4);background:linear-gradient(#b22234 0 7.7%,#fff 7.7% 15.4%,#b22234 15.4% 23.1%,#fff 23.1% 30.8%,#b22234 30.8% 38.5%,#fff 38.5% 46.2%,#b22234 46.2% 53.9%,#fff 53.9% 61.6%,#b22234 61.6% 69.3%,#fff 69.3% 77%,#b22234 77% 84.7%,#fff 84.7% 92.4%,#b22234 92.4% 100%);position:relative';
    var c = document.createElement('span');
    c.style.cssText = 'position:absolute;left:0;top:0;width:48%;height:53.8%;background:#3c3b6e';
    f.appendChild(c);
  }
  document.querySelectorAll('.wsx-flag').forEach(WSflag);
  document.querySelectorAll('[data-shoe]').forEach(function (d) { if (!d.children.length) d.innerHTML = SHOE; });

  /* announcement rotation */
  document.querySelectorAll('[data-wsx-announce]').forEach(function (el) {
    var speed = parseInt(el.getAttribute('data-speed'), 10) || 3500;
    var slides = el.querySelectorAll('.wsx-announce__slide');
    if (slides.length) {                                   /* HTML slides (supports the flag) */
      if (slides.length < 2) return;
      var si = 0;
      setInterval(function () { slides[si].classList.remove('is-active'); si = (si + 1) % slides.length; slides[si].classList.add('is-active'); }, speed);
      return;
    }
    var msgs = JSON.parse(el.getAttribute('data-wsx-announce') || '[]');  /* legacy textContent */
    if (msgs.length < 2) return;
    var i = 0;
    setInterval(function () { i = (i + 1) % msgs.length; el.textContent = msgs[i]; }, speed);
  });
  /* Dynamic free-shipping country + flag by visitor IP (GeoJS, ipwho.is fallback; cached). Single source
     of truth: updates BOTH the announcement bar (.ann-country/.ann-flag) AND the PDP trust line
     (.fg-country) together, so they always agree. (The header used to run a second, no-fallback copy that
     only touched the announcement bar — when GeoJS was throttled it left .fg-country on the default.) */
  (function () {
    var countries = document.querySelectorAll('.ann-country, .fg-country');
    var flags = document.querySelectorAll('.ann-flag');
    if (!countries.length && !flags.length) return;
    var KEY = 'ws_geo_cf', done = false;
    function apply(code, name) {
      if (done || !code || !name) return; done = true;
      countries.forEach(function (el) { el.textContent = name; });
      flags.forEach(function (img) { img.onerror = function () { this.style.display = 'none'; }; img.style.display = ''; img.src = 'https://flagcdn.com/' + String(code).toLowerCase() + '.svg'; });
    }
    try { var cc = JSON.parse(localStorage.getItem(KEY)); if (cc && cc.c && cc.n) apply(cc.c, cc.n); done = false; } catch (e) {}
    function save(code, name) { try { localStorage.setItem(KEY, JSON.stringify({ c: code, n: name })); } catch (e) {} apply(code, name); }
    fetch('https://get.geojs.io/v1/ip/country.json', { mode: 'cors' }).then(function (r) { return r.json(); })
      .then(function (d) { if (d && d.country && d.name) save(d.country, d.name); else throw 0; })
      .catch(function () { fetch('https://ipwho.is/', { mode: 'cors' }).then(function (r) { return r.json(); }).then(function (d) { if (d && d.success && d.country_code && d.country) save(d.country_code, d.country); }).catch(function () {}); });
  })();

  /* Help dropdown */
  var help = document.getElementById('wsx-help');
  var helpBtn = document.getElementById('wsx-helpBtn');
  if (help && helpBtn) {
    helpBtn.addEventListener('click', function (e) { e.stopPropagation(); var o = help.classList.toggle('open'); this.setAttribute('aria-expanded', o); });
    document.addEventListener('click', function () { help.classList.remove('open'); helpBtn.setAttribute('aria-expanded', 'false'); });
  }

  /* desktop mega menus (hover) */
  var triggers = document.querySelectorAll('.wsx-navtrig');
  var panels = {};
  document.querySelectorAll('.wsx-mega').forEach(function (p) { panels[p.dataset.panel] = p; });
  var closeT;
  function openMega(key) {
    clearTimeout(closeT);
    Object.keys(panels).forEach(function (k) { panels[k].classList.toggle('open', k === key); });
    triggers.forEach(function (t) { t.setAttribute('aria-expanded', t.dataset.mega === key); });
  }
  function closeAllMega() {
    clearTimeout(closeT);
    Object.keys(panels).forEach(function (k) { panels[k].classList.remove('open'); });
    triggers.forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
  }
  function closeMega() {
    closeT = setTimeout(closeAllMega, 320);
  }
  triggers.forEach(function (t) {
    var key = t.dataset.mega; var panel = panels[key]; if (!panel) return;
    t.addEventListener('mouseenter', function () { openMega(key); });
    t.closest('li').addEventListener('mouseleave', closeMega);
    /* A11y: opening on FOCUS made panels swap while tabbing, so panel links were never
       reachable (each next trigger's focus closed the previous panel). Keyboard flow now:
       Enter/click toggles; ArrowDown opens AND moves focus into the panel's first link. */
    t.addEventListener('click', function () { panel.classList.contains('open') ? closeMega() : openMega(key); });
    t.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        openMega(key);
        /* Defer focus to the next frame: the panel's just-applied visibility hasn't propagated
           to richer first-children (New Arrivals product cards carry a lazy image) in the same
           synchronous tick, so an immediate focus() no-ops on them and focus stays on the trigger
           (plain text-link panels happened to work). rAF lets the open state paint; the loop then
           focuses the first candidate that actually accepts focus. */
        requestAnimationFrame(function () {
          var focusables = panel.querySelectorAll('a[href], button:not([disabled])');
          for (var i = 0; i < focusables.length; i++) {
            focusables[i].focus();
            if (document.activeElement === focusables[i]) break;
          }
        });
      }
    });
    panel.addEventListener('mouseenter', function () { clearTimeout(closeT); });
    panel.addEventListener('mouseleave', closeMega);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var openTrig = document.querySelector('.wsx-navtrig[aria-expanded="true"]');
      closeAllMega();
      if (openTrig) openTrig.focus(); /* return focus to the trigger */
    }
  });
  /* close when focus or a click lands outside the trigger+panel (keyboard/touch parity
     with the hover mouseleave close — panels used to linger over the page) */
  document.addEventListener('focusin', function (e) {
    if (!document.querySelector('.wsx-mega.open')) return;
    if (e.target.closest && e.target.closest('.wsx-mega, .wsx-navtrig')) return;
    closeAllMega();
  });
  document.addEventListener('click', function (e) {
    if (!document.querySelector('.wsx-mega.open')) return;
    if (e.target.closest && e.target.closest('.wsx-mega, .wsx-navtrig')) return;
    closeAllMega();
  });

  /* T24: sticky-state shadow + REAL pinning. position:sticky had zero travel (its parent
     <ws-chrome> is exactly the topbar's height), so the header scrolled away — .is-fixed
     switches to position:fixed once the bar's flow position scrolls past, and the spacer
     preserves layout height so nothing jumps. Skipped while the body is scroll-locked
     (drawer open sets position:fixed, which zeroes scrollY and would false-unpin). */
  var wsxCloseDrawer = null;
  var topbar = document.querySelector('.wsx-topbar');
  /* Header scrolls away on EVERY page — the same behaviour as the product page (user request).
     .wsx-topbar is position:sticky with zero travel inside <ws-chrome>, so it leaves the viewport
     naturally with no fixed/pinned state and no spacer. A pinned header covered content as it
     scrolled under; hiding an in-flow sticky header (the old ws-satc-on rule) also caused a scroll
     "jump". Neither happens now. We only listen to close an open mega + drop a shadow near the top. */
  if (topbar) {
    var stuck = false;
    var syncStuck = function () {
      var s = window.scrollY > 4;
      if (s !== stuck) { stuck = s; topbar.classList.toggle('is-stuck', s); closeAllMega(); }
    };
    window.addEventListener('scroll', syncStuck, { passive: true });
    syncStuck();
  }
  /* T24: viewport (width) change closes open mega panels and the drawer.
     Width-only check so iOS URL-bar height changes don't slam the drawer shut. */
  var lastW = window.innerWidth, resizeT;
  window.addEventListener('resize', function () {
    clearTimeout(resizeT);
    resizeT = setTimeout(function () {
      if (window.innerWidth === lastW) return;
      lastW = window.innerWidth;
      closeAllMega();
      if (wsxCloseDrawer) wsxCloseDrawer();
    }, 150);
  });

  /* mobile drawer */
  var scrim = document.getElementById('wsx-scrim');
  if (scrim) {
    /* Portal the drawer overlay to <body> so it escapes the header-group section
       wrapper. Dawn gives every header-group section wrapper the same z-index (4),
       so the later countdown-bar wrapper would otherwise paint over the scrim's
       stacking context and bleed through the open drawer. As a direct body child
       the fixed scrim reliably paints above all sections. */
    if (scrim.parentNode !== document.body) { document.body.appendChild(scrim); }
    var views = scrim.querySelector('.wsx-views');
    var drawer = document.getElementById('wsx-drawer');
    var subView = scrim.querySelector('[data-sub]');
    var openMenuBtn = document.getElementById('wsx-openMenu');
    var bgEls = [document.querySelector('.wsx-topbar'), document.querySelector('.countdown-bar'), document.querySelector('#MainContent'), document.querySelector('.wsx-foot')];
    var lastFocus = null, savedScrollY = 0;

    function focusables(root) {
      return [].filter.call(root.querySelectorAll('a[href],button:not([disabled]),input,[tabindex]:not([tabindex="-1"])'), function (el) { return el.offsetParent !== null; });
    }
    function trapFocus(e) {
      if (e.key !== 'Tab') return;
      var f = focusables(drawer); if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    /* T26: body scroll lock incl. iOS — overflow:hidden plus position:fixed
       fallback (keeps the page pinned, no rubber-banding behind the drawer). */
    function lockBg() {
      savedScrollY = window.scrollY;
      bgEls.forEach(function (el) { if (el) { el.setAttribute('inert', ''); el.setAttribute('aria-hidden', 'true'); } });
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed'; document.body.style.top = (-savedScrollY) + 'px'; document.body.style.left = '0'; document.body.style.right = '0'; document.body.style.width = '100%';
    }
    function unlockBg() {
      bgEls.forEach(function (el) { if (el) { el.removeAttribute('inert'); el.removeAttribute('aria-hidden'); } });
      document.body.style.overflow = '';
      document.body.style.position = ''; document.body.style.top = ''; document.body.style.left = ''; document.body.style.right = ''; document.body.style.width = '';
      window.scrollTo(0, savedScrollY);
    }
    function openDrawer() {
      lastFocus = document.activeElement;
      scrim.classList.add('open'); openMenuBtn.setAttribute('aria-expanded', 'true'); lockBg();
      drawer.addEventListener('keydown', trapFocus);
      setTimeout(function () { var c = document.getElementById('wsx-closeMenu'); if (c) c.focus(); }, 80);
    }
    function closeDrawer() {
      if (!scrim.classList.contains('open')) return;
      scrim.classList.remove('open'); openMenuBtn.setAttribute('aria-expanded', 'false');
      drawer.removeEventListener('keydown', trapFocus); unlockBg();
      if (lastFocus && lastFocus.focus) lastFocus.focus();
      setTimeout(function () { views.classList.remove('sub'); showSub(null); }, 300);
    }
    wsxCloseDrawer = closeDrawer;
    openMenuBtn.addEventListener('click', openDrawer);
    document.getElementById('wsx-closeMenu').addEventListener('click', closeDrawer);
    scrim.querySelectorAll('[data-close]').forEach(function (x) { x.addEventListener('click', closeDrawer); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && scrim.classList.contains('open')) closeDrawer(); });

    function showSub(key) {
      subView.querySelectorAll('[data-wsx-sub]').forEach(function (s) { s.hidden = (s.getAttribute('data-wsx-sub') !== key); });
    }
    scrim.querySelectorAll('[data-wsx-key]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-wsx-key');
        if (key === 'finder') { startQuiz(); }
        /* Set the sub content FIRST, then start the slide on a later frame.
           Toggling the pre-rendered sub blocks' `hidden` changes the flex pane's
           rendered height; doing that in the same frame that the translateX
           transition begins makes Chromium composite the transform against a
           stale box, landing the pane ~329px too far left. A double rAF lets
           layout settle so the transition runs against a stable pane size. */
        showSub(key);
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            views.classList.add('sub');
            var first = subView.querySelector('[data-wsx-sub="' + key + '"]');
            if (first) { var f = first.querySelector('a,button'); if (f) { f.focus(); } }
          });
        });
      });
    });
    scrim.querySelectorAll('[data-wsx-back]').forEach(function (b) { b.addEventListener('click', function () { views.classList.remove('sub'); }); });

    /* drawer accordions */
    scrim.querySelectorAll('.wsx-acc').forEach(function (acc) {
      var head = acc.querySelector('.wsx-acc__head'), panel = acc.querySelector('.wsx-acc__panel');
      head.addEventListener('click', function () {
        var open = acc.classList.toggle('open');
        head.setAttribute('aria-expanded', open);
        panel.style.maxHeight = open ? (panel.scrollHeight + 20) + 'px' : '0px';
        var plus = acc.querySelector('.ic-plus'), minus = acc.querySelector('.ic-minus');
        if (plus) plus.style.display = open ? 'none' : '';
        if (minus) minus.style.display = open ? '' : 'none';
      });
    });

    /* ---- Shoe Finder quiz ---- */
    var quizMount = scrim.querySelector('[data-wsx-quiz]');
    var QUIZ_STEPS = [], QUIZ_MATCHES = [];
    var quizCfg = document.getElementById('wsx-quiz-data');
    if (quizCfg) { try { var _qd = JSON.parse(quizCfg.textContent); QUIZ_STEPS = _qd.steps || []; QUIZ_MATCHES = _qd.matches || []; } catch (e) {} }
    var quizShopUrl = (quizCfg && quizCfg.getAttribute('data-shop-url')) || '/collections/all';
    /* Result thumbnails: real product photos (BareFlex / Elora / Marcay) supplied via the quiz data,
       each linking to its product; falls back to the placeholder shoe if an image is missing. */
    function qThumbs() {
      var m = (QUIZ_MATCHES && QUIZ_MATCHES.length) ? QUIZ_MATCHES.slice(0, 3) : [null, null, null];
      return m.map(function (p) {
        var body = (p && p.img) ? '<img src="' + p.img + '" alt="' + String(p.alt || '').replace(/"/g, '&quot;') + '" loading="lazy" width="74" height="74">' : SHOE;
        return (p && p.url) ? '<a class="wsx-qz-res__thumb" href="' + p.url + '">' + body + '</a>' : '<div class="wsx-qz-res__thumb">' + body + '</div>';
      }).join('');
    }
    var qStep = 0, qAns = {};
    var QCHEV = '<svg class="wsx-qz-chev" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/></svg>';

    function qUniq(a) { var o = []; a.forEach(function (x) { if (x && o.indexOf(x) < 0) o.push(x); }); return o; }
    function qJoin(a) { if (a.length <= 1) return a[0] || ''; if (a.length === 2) return a[0] + ' and ' + a[1]; return a.slice(0, -1).join(', ') + ', and ' + a[a.length - 1]; }
    function qResultCopy(a) {
      var c = a.concern || [], fit = a.fit, t = [];
      if (fit === 'wide') t.push('wide-fit'); else if (fit === 'xwide') t.push('extra-wide'); else if (fit === 'swell') t.push('roomy'); else if (fit === 'support') t.push('supportive');
      if (c.indexOf('bunions') >= 0) t.push('bunion-friendly');
      if (c.indexOf('heel') >= 0) t.push('cushioned');
      if (c.indexOf('arthritis') >= 0) t.push('easy-on');
      if (c.indexOf('nerve') >= 0) t.push('protective');
      if (c.indexOf('swell') >= 0) t.push('roomy');
      if (c.indexOf('kneeback') >= 0) t.push('supportive');
      t = qUniq(t); if (!t.length) { t.push('roomy'); t.push('comfortable'); } t = t.slice(0, 3);
      var echo = 'Based on your answers, we matched you with ' + qJoin(t) + ' styles.';
      var re;
      if (c.indexOf('heel') >= 0) re = 'Our roomy, low-drop styles help ease heel and arch strain, with no narrow toe box crowding your foot.';
      else if (c.indexOf('nerve') >= 0) re = 'Seam-light, non-binding styles with room to spare, so nothing rubs where you cannot feel it.';
      else if (c.indexOf('arthritis') >= 0) re = 'Flexible, cushioned, easy-on styles that go gentle on stiff joints.';
      else if (c.indexOf('bunions') >= 0) re = 'Room at the toes to take the pressure off your bunions.';
      else if (c.indexOf('swell') >= 0 || fit === 'swell') re = 'Adjustable, roomy styles that stay comfortable even when your feet swell.';
      else re = 'Roomy, flexible styles that let your feet move and breathe all day.';
      return { echo: echo, re: re };
    }
    function renderQuiz() {
      if (!quizMount) return;
      var inner;
      if (qStep < QUIZ_STEPS.length) {
        var s = QUIZ_STEPS[qStep];
        var sel = s.multi ? (qAns[s.key] || []) : null;
        var opts = s.opts.map(function (o) {
          if (s.multi) { var on = sel.indexOf(o.v) >= 0; return '<button class="wsx-qz-opt wsx-qz-opt--multi' + (on ? ' sel' : '') + '" type="button" data-v="' + o.v + '" aria-pressed="' + on + '"><span class="wsx-qz-opt__label">' + o.l + '</span><span class="wsx-qz-check" aria-hidden="true"></span></button>'; }
          return '<button class="wsx-qz-opt" type="button" data-v="' + o.v + '"><span class="wsx-qz-opt__label">' + o.l + '</span>' + QCHEV + '</button>';
        }).join('');
        inner = '<div class="wsx-qz"><div class="wsx-qz-dots">' + QUIZ_STEPS.map(function (_, i) { return '<span class="wsx-qz-dot' + (i <= qStep ? ' on' : '') + '"></span>'; }).join('') + '</div>' +
          '<div class="wsx-qz-q">' + s.q + '</div><div class="wsx-qz-qsub">' + s.sub + '</div>' +
          (s.help ? '<div class="wsx-qz-help">' + s.help + '</div>' : '') +
          '<div class="wsx-qz-opts">' + opts + '</div>' +
          (s.multi ? '<button class="wsx-qz-continue" type="button" id="wsx-qCont"' + ((sel && sel.length) ? '' : ' disabled') + '>Continue</button>' : '') + '</div>';
      } else {
        var rc = qResultCopy(qAns);
        inner = '<div class="wsx-qz wsx-qz-res"><div class="wsx-qz-res__eyebrow">Your matches are ready</div>' +
          '<div class="wsx-qz-res__thumbs">' + qThumbs() + '</div>' +
          '<div class="wsx-qz-res__name">We found shoes made for your feet</div>' +
          '<div class="wsx-qz-res__tag">' + rc.echo + ' ' + rc.re + '</div>' +
          '<a class="wsx-qz-res__cta" href="' + quizShopUrl + '" id="wsx-qShop">Shop your matches</a>' +
          '<button class="wsx-qz-res__retake" type="button" id="wsx-qRetake">Retake the quiz</button></div>';
      }
      quizMount.innerHTML = inner;
      var step = QUIZ_STEPS[qStep];
      function syncMulti() { var arr = qAns[step.key] || []; quizMount.querySelectorAll('.wsx-qz-opt--multi').forEach(function (b) { var on = arr.indexOf(b.getAttribute('data-v')) >= 0; b.classList.toggle('sel', on); b.setAttribute('aria-pressed', on); }); var cn = quizMount.querySelector('#wsx-qCont'); if (cn) cn.disabled = !arr.length; }
      quizMount.querySelectorAll('.wsx-qz-opt').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var v = btn.getAttribute('data-v');
          if (step && step.multi) {
            var arr = qAns[step.key] || (qAns[step.key] = []); var ex = step.exclusive;
            if (ex && v === ex) { qAns[step.key] = (arr.indexOf(v) >= 0) ? [] : [v]; }
            else { var i = arr.indexOf(v); if (i >= 0) arr.splice(i, 1); else arr.push(v); if (ex) { var ei = arr.indexOf(ex); if (ei >= 0) arr.splice(ei, 1); } qAns[step.key] = arr; }
            syncMulti();
          } else { qAns[step.key] = v; qStep++; renderQuiz(); }
        });
      });
      var cont = quizMount.querySelector('#wsx-qCont'); if (cont) cont.addEventListener('click', function () { var arr = qAns[step.key]; if (arr && arr.length) { qStep++; renderQuiz(); } });
      var rt = quizMount.querySelector('#wsx-qRetake'); if (rt) rt.addEventListener('click', function () { qStep = 0; qAns = {}; renderQuiz(); });
      var shop = quizMount.querySelector('#wsx-qShop'); if (shop) shop.addEventListener('click', function () { closeDrawer(); });
    }
    function startQuiz() { qStep = 0; qAns = {}; renderQuiz(); }
  }

  /* mobile / tablet search overlay */
  (function () {
    var ov = document.getElementById('wsx-srchOv'), openS = document.getElementById('wsx-openSearch'), closeS = document.getElementById('wsx-closeSearch');
    if (!ov || !openS) return;
    var inp = ov.querySelector('input'), prevFocus = null;
    function openOv() { prevFocus = document.activeElement; ov.classList.add('open'); openS.setAttribute('aria-expanded', 'true'); document.body.style.overflow = 'hidden'; setTimeout(function () { inp.focus(); }, 80); }
    function closeOv() { ov.classList.remove('open'); openS.setAttribute('aria-expanded', 'false'); document.body.style.overflow = ''; if (prevFocus && prevFocus.focus) prevFocus.focus(); }
    openS.addEventListener('click', openOv);
    if (closeS) closeS.addEventListener('click', closeOv);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && ov.classList.contains('open')) closeOv(); });
  })();
})();
